import React from 'react';

const AbideLogos = ({ content, bgColor }) => {
  return (
    <div className="abide-logos-wrapper">
      <h2 className="abide-logos-title heading-2">{content.title}</h2>
      <div className="abide-logos-rows">
        {content.logos.map((logosRow, i) => {
          return (
            <div key={i} className="abide-logos-row">
              {logosRow.map((img, i) => {
                return (
                  <div key={i+10} className="abide-img-wrapper">
                    <img className="abide-logo-img"  src={img.img} alt={img.alt} />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AbideLogos;
